import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import styles from './AnimalViewTabRail.module.css';

export type AnimalViewTabValue =
  | 'overview'
  | 'digitalTwin'
  | 'notes'
  | 'locationHistory'
  | 'externalId'
  | 'health'
  | 'feed';

type Translate = (key: string) => string;

export type AnimalViewTabRailProps = {
  value: AnimalViewTabValue | string;
  onChange: (event: React.ChangeEvent<unknown>, newValue: string) => void;
  hasDigitalTwin: boolean;
  /** When true, bottom border is removed so an entry card can sit flush below. */
  attachEntryCardBelow: boolean;
  t: Translate;
};

export const AnimalViewTabRail: React.FC<AnimalViewTabRailProps> = ({
  value,
  onChange,
  hasDigitalTwin,
  attachEntryCardBelow,
  t
}) => {
  const digitalTwinLabel = (
    <span className={styles.tabLabel}>
      <span className={styles.tabLabelText}>{t('digitalTwin.tabLabel')}</span>
      <span className={styles.tabIntegratedBadge}>{t('digitalTwin.tabBadge')}</span>
    </span>
  );

  const railClass = `${styles.tabRail} ${attachEntryCardBelow ? styles.tabRailAttached : styles.tabRailStandalone}`;

  return (
    <Tabs
      value={value}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      className={railClass}
      classes={{
        flexContainer: styles.tabRailFlex,
        indicator: styles.tabRailIndicator
      }}
    >
      <Tab
        label={t('f-animal-view-title')}
        id="overviewTab"
        value="overview"
        classes={{
          root: styles.tabButtonRoot,
          selected: styles.tabButtonSelected,
          wrapper: styles.tabButtonWrapper
        }}
      />
      {hasDigitalTwin && (
        <Tab
          label={digitalTwinLabel}
          id="digitalTwinTab"
          value="digitalTwin"
          classes={{
            root: `${styles.tabButtonRoot} ${styles.tabButtonRootDigitalTwin}`,
            selected: `${styles.tabButtonSelected} ${styles.tabButtonSelectedDigitalTwin}`,
            wrapper: styles.tabButtonWrapper
          }}
        />
      )}
      <Tab
        label={t('f-animal-tab-notes')}
        id="notesTab"
        value="notes"
        classes={{
          root: styles.tabButtonRoot,
          selected: styles.tabButtonSelected,
          wrapper: styles.tabButtonWrapper
        }}
      />
      <Tab
        label={t('f-animal-tab-location-history')}
        id="locationHistoryTab"
        value="locationHistory"
        classes={{
          root: styles.tabButtonRoot,
          selected: styles.tabButtonSelected,
          wrapper: styles.tabButtonWrapper
        }}
      />
      <Tab
        label={t('f-animal-tab-external-id')}
        id="externalIdTab"
        value="externalId"
        classes={{
          root: styles.tabButtonRoot,
          selected: styles.tabButtonSelected,
          wrapper: styles.tabButtonWrapper
        }}
      />
      <Tab
        label={t('f-animal-tab-health')}
        id="healthTab"
        value="health"
        classes={{
          root: styles.tabButtonRoot,
          selected: styles.tabButtonSelected,
          wrapper: styles.tabButtonWrapper
        }}
      />
      <Tab
        label={t('f-feed-reg-tab')}
        id="feedTab"
        value="feed"
        classes={{
          root: styles.tabButtonRoot,
          selected: styles.tabButtonSelected,
          wrapper: styles.tabButtonWrapper
        }}
      />
    </Tabs>
  );
};
